import { LANGUAGE_CODES } from './Languages';

const isValidLanguage = (
  languageCode?: string,
  languageCodes?: string[],
): languageCode is string => (
  (languageCodes ?? LANGUAGE_CODES).includes(languageCode ?? '')
);

interface LanguageOpts {
  language?: string;
  fallbackLanguage?: string;
  languageCodes?: string[];
}

const getSupportedLanguage = ({
  language,
  fallbackLanguage,
  languageCodes,
}: LanguageOpts) => {
  const languageCode = language?.toLowerCase();
  if (isValidLanguage(languageCode, languageCodes)) {
    return languageCode;
  }

  if (isValidLanguage(fallbackLanguage, languageCodes)) {
    return fallbackLanguage;
  }

  if (languageCodes?.length) {
    return languageCodes[0];
  }

  return 'en';
};

export default getSupportedLanguage;
